import React, { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faRotateLeft,
  faTrash,
  faUser,
  faUsers,
} from '@fortawesome/free-solid-svg-icons'

import { ConfirmModal, AlertModal } from './Modal'

function OrderListItem(props) {
  const [pendingAction, setPendingAction] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')
  const cancelled = !!props.order.deletedAt

  async function performDelete() {
    try {
      const resp = await fetch(
        'https://app.cutcatering.it/api/orders/' + props.order._id,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': localStorage.getItem('cut-catering-token'),
          },
        },
      )
      if (!resp.ok) {
        setErrorMessage('Cancellazione fallita.')
        return
      }
      props.onChanged?.()
    } catch (e) {
      setErrorMessage('Errore di rete. Riprova.')
    }
  }

  async function performRestore() {
    try {
      const resp = await fetch(
        'https://app.cutcatering.it/api/orders/' +
          props.order._id +
          '/restore',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': localStorage.getItem('cut-catering-token'),
          },
        },
      )
      if (!resp.ok) {
        setErrorMessage('Ripristino fallito.')
        return
      }
      props.onChanged?.()
    } catch (e) {
      setErrorMessage('Errore di rete. Riprova.')
    }
  }

  const askDelete = () =>
    setPendingAction({
      title: 'Cancellare questo ordine?',
      message: `Verrà rimosso dagli ordini attivi e dalla cucina. Potrai ripristinarlo dal filtro "Cancellati".`,
      confirmLabel: 'Sì, cancella',
      run: performDelete,
    })

  const askRestore = () =>
    setPendingAction({
      title: 'Ripristinare questo ordine?',
      message: `L'ordine tornerà tra quelli attivi e sarà di nuovo visibile in cucina.`,
      confirmLabel: 'Sì, ripristina',
      run: performRestore,
    })

  return (
    <div className={`card order-status-card${cancelled ? ' order-cancelled' : ''}`}>
      <div className="card-row">
        <div className="card-col col-w-140">
          {props.onChanged ? (
            <p className="card-title">
              {cancelled && (
                <span className="order-cancelled-badge">Cancellato</span>
              )}
              <span className="card-title-name">
                {props.order.customer || 'Cliente'}
              </span>
            </p>
          ) : null}
          <p className="card-subtitle">
            <FontAwesomeIcon
              icon={props.order.type === 'producer' ? faUsers : faUser}
            />{' '}
            {props.order.name || 'Name'}
          </p>
          <p className="card-order-date">{formatTime(props.order.time)}</p>
          {cancelled && props.order.cancelledBy && (
            <p className="card-subtitle2">
              Annullato da: {props.order.cancelledBy}
            </p>
          )}
        </div>
        <div className="card-col col-w100">
          {props.order.items?.map((el, key) => (
            <p key={key} className="order-item-element">
              <span className="order-item-count">{el.quantity}</span> x{' '}
              {el.name}
            </p>
          ))}
        </div>
        {props.onChanged ? (
          <div className="edit-link" onClick={cancelled ? askRestore : askDelete}>
            <FontAwesomeIcon icon={cancelled ? faRotateLeft : faTrash} />
          </div>
        ) : null}
      </div>
      <ConfirmModal
        open={!!pendingAction}
        title={pendingAction?.title}
        message={pendingAction?.message}
        confirmLabel={pendingAction?.confirmLabel}
        danger
        onConfirm={() => {
          const action = pendingAction
          setPendingAction(null)
          if (action) action.run()
        }}
        onCancel={() => setPendingAction(null)}
      />
      <AlertModal
        open={!!errorMessage}
        title="Operazione non riuscita"
        message={errorMessage}
        onClose={() => setErrorMessage('')}
      />
    </div>
  )
}

function formatTime(time) {
  let yourDate = new Date(time)
  const offset = yourDate.getTimezoneOffset()
  yourDate = new Date(yourDate.getTime() - offset * 60 * 1000)
  return yourDate.toISOString().split('.')[0].split('T').join(' ')
}

export default OrderListItem
